<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="block">
            <el-date-picker size="mini" v-model="params.times" clearable type="daterange" :picker-options="pickerOptions"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="7">
          <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-button size="mini" type="primary" @click="create()">新建+</el-button>
      </el-row>

      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="title" label="活动标题"></el-table-column>
        <el-table-column prop="created_at_text" label="创建时间"></el-table-column>
        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <el-tag type="info"> {{ scope.row.start_time_text }} ~ {{ scope.row.end_time_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success"> 开启</el-tag>
            <el-tag v-else type="info">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="create(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]" :total="total_count"
          :page-size="params.pagesize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import {
  mapGetters
} from "vuex";
import draggable from "vuedraggable";
import {
  getOrderCardList, getOrderCardRow, saveOrderCard, editOrderCard, delOrderCard
} from "@/api/cardticket";
export default {
  components: {
    draggable
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dialogVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      dataList: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    create(id = '') {
      if (!id) {
        this.$router.push({ path: this.matchHidePage("editor") });
      } else {
        this.$router.push({
          path: this.matchHidePage("editor"),
          query: { id: id },
        });
      }
    },
    getDataList() {
      this.loading = true;
      getOrderCardList(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
    },
    del(id, index) {
      this.$confirm('确定删除么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delOrderCard(id).then(response => {
          this.$message({
            type: "success",
            message: response.data.data.msg,
          })
          this.dataList.splice(index, 1);
        })
      });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
  },
  mounted() {
    this.getDataList();
  },
  provide() {
    return {
      refresh: this.getDataList
    }
  },

};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// list.vue?068e2224